export const BASE_URI = "/api/agent";
export const OPEN_URI = "/api/open";
//监控图片oss路径前缀
export const INVIGILATE_PREFIX = "monitor-file/"
